<template>
  <div>
      <MaskLayout :isShow="isShow" @closeMask="closeMask" :contentStyle="wrapStyle">
          <div class="movie-wrapper">
              <!-- icon -->
              <div class="movie-box acea-row row-center" v-if="types == 'type1' || types == 'type2'">
                  <img class="mt6 icon-div" v-if="types == 'type1'" src="@/assets/images/sf_icon_chenggong.png" />
                  <img class="mt6 icon-div" v-if="types == 'type2'" src="@/assets/images/sf_icon_shibai.png" />
              </div>
              <!-- 内容 -->
              <div class="mt4">
                  <!-- 一行 -->
                  <p class="black-color font-size32 font-weight550 page-text-center" :class="{'mt6': types == 'type3'}" v-if="types == 'type1' || types == 'type3'">{{content.title}}</p>
                  <!-- 两行 -->
                  <div v-if="types == 'type2' || types == 'type4'">
                    <p class="black-color font-size32 font-weight550 page-text-center mt6">{{content && content.title}}</p>
                    <p class="color6D6D6D font-size28 page-text-center mt2">{{content && content.tips}}</p>
                  </div>
              </div>
              <!-- 底部按钮部分 -->
              <div class="movie-box mt4 mb6">
                  <div class=" bgdF34B26 font-size28 colorWhite page-text-center btn-div" v-if="types == 'type1' || types == 'type2'" @click="content.sfDetermine()">{{btnCont}}</div>
                  <!-- 两个按钮 -->
                  <div class="movie-box acea-row row-column-around row-middle botton-div-wrap mt3" v-if="types == 'type3' || types == 'type4'">
                      <span class="btn-n bgdE2E2E2 page-text-center font-size28 color2B2B2B no-btn" v-if="types == 'type3'" @click="cancel">{{btnText && btnText.no || '否'}}</span>
                      <span class="btn-n bgdF34B26 page-text-center font-size28 colorWhite yes-btn" v-if="types == 'type3'" @click="content.sfDetermine()">{{btnText && btnText.yes || '是'}}</span>
                      <!--  -->
                      <span class="btn-n bgdE2E2E2 page-text-center font-size28 color2B2B2B no-btn" v-if="types == 'type4'" @click="cancel">取消</span>
                      <span class="btn-n bgdF34B26 page-text-center font-size28 colorWhite yes-btn" v-if="types == 'type4'" @click="content.sfDetermine()">确定</span>
                  </div>
              </div>
          </div>
      </MaskLayout>
  </div>
</template>

<script>
import MaskLayout from "@components/MaskLayout.vue";
export default {
    name: "SpringFrame",
    props: {
        types: {
            type: String,
            default: 'type2'
            // type1 = 绑定成功 = icon + 标题 + 1个按钮;
            // type2 = 该卡券已被绑定 = icon + 标题 内容 + 1个按钮;
            // type3 = 是否切换专区 || 还未绑定卡券 = 标题 + 2个按钮;
            // type4 = 确定解绑该卡券？=  标题 内容 + 2个按钮;
        },
        content: {
            type: Object,
            default: ()=>{}
        },
        btnCont: {
            type: String,
            default: '我知道了'
        },
        isShow: {
            type: Boolean,
            default: false
        },
        btnText: {
            type: Object,
            default: ()=>{}
        }
    },
    components: {
        MaskLayout
    },
    data: function () {
        return {
            wrapStyle: {
                "top": "40%",
                "left": "50%",
                "transform": "translate(-50%,-50%)",
                "width": "80%",
                "height": "auto",
                "border-radius": "0.06rem"
            },
        }
    },
    methods: {
        closeMask: function (val) {
            this.$emit("closeMask", val);
        },
        // 取消、否
        cancel: function () {
            this.closeMask(false);
        }
    }
}
</script>

<style scoped>
.icon-div {
    width: 1.48rem;
    height: auto;
}
.black-color {
    color: #2B2B2B;
}

.btn-div {
    width: 100%;
    height: .76rem;
    line-height: .76rem;
    border-radius: 0.08rem;
}
.botton-div-wrap {
    height: 0.76rem;
}
.btn-n {
    width: 2rem;
    height: .76rem;
    line-height: .76rem;
    border-radius: 0.08rem; 
}
.no-btn {

}
.yes-btn {

}
</style>